export default "__VITE_ASSET__C02MKACv__"